/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prettier/prettier */
/* eslint-disable indent */
import { AxiosPromise } from 'axios';
import api from './api';
import { Filters } from '../interfaces/core';
import {
  RechargeTicketOrderFilter,
  CreateRechargeTicket,
  ConfirmRechargeTicketData,
  UpdateRechargeTicketOrderData,
} from '../interfaces/recharge';

const ConvertArrayFilterToObject = (
  filters: Filters = {},
): RechargeTicketOrderFilter => {
  try {
    const object = filters.reduce(
      (obj: any, item: any) => ({ ...obj, ...item }),
      {},
    );
    return object;
  } catch (err) {
    return {};
  }
};

const SerializeFilters = (filters: any): string => {
  const str = [];
  for (const p in filters) {
    if (filters.hasOwnProperty(p)) {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(filters[p])}`);
    }
  }
  return str.join('&');
};

class RechargeService {
  getRechargeOrders = (filters?: Filters): AxiosPromise => {
    const convertedFilters = ConvertArrayFilterToObject(filters?.filters);
    const url = !convertedFilters
      ? 'api/pjtacom/recharge/'
      : `api/pjtacom/recharge/?${SerializeFilters(convertedFilters)}`;
    return api.get(url);
  };

  getRechargeReport = (filters?: Filters, type?: string): AxiosPromise => {
    const convertedFilters = ConvertArrayFilterToObject(filters?.filters);
    const headers: any =
      type === 'csv' ? null : { responseType: 'arraybuffer' };

    const url = `api/pjtacom/report/order-recharge?${SerializeFilters(
      convertedFilters,
    )}`;
    return api.get(url, headers);
  };

  createRechargeOrders = (data: CreateRechargeTicket): AxiosPromise => {
    const url = `api/pjtacom/recharge/?type-recharge=${data['type-recharge']}`;
    return api.post(url, data.data);
  };

  removeRechargeOrder = (code: string): AxiosPromise => {
    const url = `api/pjtacom/recharge/${code}/`;
    return api.delete(url);
  };

  confirmRechargeOrder = (data: ConfirmRechargeTicketData): AxiosPromise => {
    const url = 'api/pjtacom/recharge/confirm/';
    return api.post(url, data);
  };

  rechargeImport = (data?: any): AxiosPromise => {
    const url = 'api/pjtacom/recharge/import/';
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };
    return api.post(url, data, config);
  };

  cancelRechargeOrder = (code: string): AxiosPromise => {
    const url = `api/pjtacom/recharge/${code}/cancel/`;
    return api.post(url);
  };

  getRechargeBillet = (code: string): AxiosPromise => {
    const url = `api/pjtacom/recharge/${code}/billet/`;
    return api.get(url, { responseType: 'arraybuffer' });
  };

  getRechargeReceipt = (code: string): AxiosPromise => {
    const url = `api/pjtacom/recharge/${code}/receipt/`;
    return api.get(url, { responseType: 'arraybuffer' });
  };

  getEmployeesRechargeOrder = (
    filters: Filters,
    code: string,
  ): AxiosPromise => {
    const convertedFilters = ConvertArrayFilterToObject(filters?.filters);
    const url = !convertedFilters
      ? `api/pjtacom/recharge/${code}/items/`
      : `api/pjtacom/recharge/${code}/items/?${SerializeFilters(
          convertedFilters,
        )}`;
    return api.get(url);
  };

  updateEmployeesRechargeOrder = (
    data: UpdateRechargeTicketOrderData,
  ): AxiosPromise => {
    const url = `api/pjtacom/recharge/${data.CodigoPedido}/`;
    return api.patch(url, data);
  };

  getRechargeByTicket = (): AxiosPromise => {
    return api.get('api/pjtacom/recharge/by-ticket');
  };
}

export default RechargeService;
